import { MutableRefObject } from "react";
import { Parsed, ParsingRequest, ParsingRequestContext } from "./types";

export const parseTagQuery = (
  s: string,
  parsingRequests: MutableRefObject<ParsingRequest[]>,
) => {
  
  const trimedS = (s || '').trim();
  const value = trimedS.replace(/^#/, '')

  const process = ({
    tagOptions
  }: ParsingRequestContext) : ParsingRequest => {
    const tag = tagOptions.find(tag => tag.text.toLocaleLowerCase() === value.toLocaleLowerCase())
    const hasSimilar = !value || !!tag || tagOptions.some(tag => tag.text.toLocaleLowerCase().indexOf(value.toLocaleLowerCase()) > -1)
    const end: ParsingRequest = {
      value: s,
      process: () => end,
      finished: true,
      result: {
        raw: s,
        guess: [],
        ast: {
          kind: 'Tag',
          prefix: '#',
          value: tag ? tag.text : value,
          id: tag?.key,
        },
        ...(!tag && !hasSimilar && {
          error: 'no matching tag is found',
          position: [0, value.length - 1]
        })
      },
    }
    return end
  }

  const start: ParsingRequest = {
    value: s,
    process,
    finished: false,
  }

  parsingRequests.current.push(start)
}

